document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.js-accordion-header');

  // Open all accordions by default except Ingredients (data-index="6")
  accordionHeaders.forEach(header => {
    if (header.dataset.index !== '6') {
      const content = document.querySelector(`.js-accordion-content[data-index="${header.dataset.index}"]`);
      if (content) {
        header.classList.add('active');
        content.classList.add('active');
      }
    }
  });

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const content = document.querySelector(`.js-accordion-content[data-index="${this.dataset.index}"]`);
      const isActive = this.classList.contains('active');

      // Toggle only the clicked section
      if (isActive) {
        this.classList.remove('active');
        content.classList.remove('active');
      } else {
        this.classList.add('active');
        content.classList.add('active');
      }
    });
  });
});